module.exports = __webpack_public_path__ + "img/search-no-data.ae3d7597.png";